import { MatTableDataSource} from '@angular/material/table';

export class HttpPaginatedDataSource<T> extends MatTableDataSource<T> {

  /**
   * Override update paginator method
   * to ensure total unfiltered element count is consistent with the http result
   */
  public _updatePaginator(filteredDataLength: number)  {
    super._updatePaginator(filteredDataLength);
  }
}
